var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Translate } from "../../../../I18N";

import { Pill } from "../../UI/Pill";








const MultiselectListButtonItem = ({
  item,
  selected,
  onClick,
  itemClassName
}) => {
  const borderSyles = selected ?
  'border-success-200' :
  'border-transparent hover:border-primary-300';

  return (/*#__PURE__*/
    _jsx("li", { className: `${itemClassName !== null && itemClassName !== void 0 ? itemClassName : 'bg-gray-50 rounded-lg mb-4'}` }, item.value, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: `w-full flex text-left p-2.5 border ${borderSyles} rounded-lg items-center`,
      onClick: onClick }, void 0, /*#__PURE__*/

    _jsx("span", { className: "flex-1" }, void 0, item.label), /*#__PURE__*/
    _jsx("div", { className: "flex-1" }, void 0, /*#__PURE__*/
    _jsx(Pill, { className: "float-right", color: selected ? 'green' : 'primary' }, void 0,
    selected ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Selected") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Select")
    )
    )
    )
    ));

};

export { MultiselectListButtonItem };